import { render } from "./DedicateDomain.vue?vue&type=template&id=de1cd752&scoped=true"
import script from "./DedicateDomain.vue?vue&type=script&lang=js"
export * from "./DedicateDomain.vue?vue&type=script&lang=js"

import "./DedicateDomain.vue?vue&type=style&index=0&id=de1cd752&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de1cd752"]])

export default __exports__